
import Vue from 'vue';
import AlertComponent from '@/components/AlertComponent.vue';
import axios from 'axios';
import goTo from 'vuetify/lib/services/goto';

export default Vue.extend({
  name: 'BoxTabComponent',
  components: {
    AlertComponent,
  },
  props: [],
  data: () => ({
    valid: false,
    showNewBoxNumber: false,
    newBoxNumber: null,
    houseId: null,
    houseIdRules: [
      (v: number) => !!v || 'House is required',
    ],
    houses: [] as object[],
    floorDisabled: true,
    floorId: null,
    floorIdRules: [
      (v: number) => !!v || 'Floor is required',
    ],
    floors: [] as object[],
    roomDisabled: true,
    roomId: null,
    roomIdRules: [
      (v: number) => !!v || 'Room is required',
    ],
    rooms: [] as object[],
    shelfDisabled: true,
    shelfId: null,
    shelfIdRules: [
      (v: number) => !!v || 'Shelf is required',
    ],
    shelves: [] as object[],
    browseImage: null,
    browseImageRules: [
      // (v: File) => !!v || 'Image is required',
      (v: File) => !v || v.size < (10 * 1000000) || 'Image size should be less than 10 mb',
    ],
    browseImageFile: '',
    previewSelectedImage: '',
    alertData: [] as object[],
    uploadedImageId: null,
  }),
  created() {
    this.loadHouses();
  },
  mounted() {
    this.$root.$on('boxTabUpdateCollection', (toggle: boolean) => {
      if (toggle) {
        this.formEl.reset();
        this.floorDisabled = true;
        this.roomDisabled = true;
        this.shelfDisabled = true;
        this.houses = [] as object[];
        this.loadHouses();
      }
    });
  },
  computed: {
    formEl() {
      return (this.$refs.form as Vue & {
        validate: () => boolean,
        reset: () => boolean
      });
    },
    previewSelectedImageEl() {
      return (this.$refs.previewSelectedImage as Vue & {
        el: object,
      });
    },
  },
  watch: {
    houseId() {
      if (this.houseId) {
        this.floorDisabled = false;
        this.floors = [] as object[];
        this.loadFloors(this.houseId);
      }
    },
    floorId() {
      if (this.floorId) {
        this.roomDisabled = false;
        this.rooms = [] as object[];
        this.loadRooms(this.floorId);
      }
    },
    roomId() {
      if (this.roomId) {
        this.shelfDisabled = false;
        this.shelves = [] as object[];
        this.loadShelves(this.roomId);
      }
    },
    browseImage() {
      const el = this.previewSelectedImageEl.$el;
      if (this.browseImage) {
        this.previewSelectedImage = URL.createObjectURL(this.browseImage);
        el?.removeAttribute('style');
      } else {
        this.previewSelectedImage = '';
        el?.setAttribute('style', 'display: none;');
      }
    },
  },
  methods: {
    browseImageFileOnChangeEvent(file: never) {
      // eslint-disable-next-line prefer-destructuring
      this.browseImageFile = file;
    },
    testSubmitData() {
      this.formEl.validate();
    },
    async loadHouses() {
      await axios
        .get(`${this.$store.getters.getApiUrl}/api/homes`, {
          headers: {
            'X-AUTH-TOKEN': this.$store.getters.getApiToken,
          },
          params: {
            account_id: this.$store.getters.getAccountId,
            'order[id]': 'DESC',
          },
          responseType: 'json',
        })
        .then((response) => {
          response.data.forEach((value: { id: number, name: string, floors: [] }) => {
            this.houses.push({
              text: `${value.name} (${value.floors.length} floors)`,
              value: value.id,
            });
          });

          // auto select a house if there is only one selection
          if (this.houses.length === 1) {
            const singleHouseData = JSON.parse(JSON.stringify(this.houses[0]));
            this.houseId = singleHouseData.value;
          }
        })
        .catch((error) => {
          /** Authentication checker
           * @TODO optimize this code, make a base interface for this codes aside from validating
           * each page route changed in router/index.ts
           * */
          if (error.response.data.message === 'Invalid credentials.'
            || error.response.status === 401) {
            this.$store.commit('updateAuthenticatedAccount', {
              accountId: null,
              apiToken: null,
            });
            this.$router.push({
              name: 'login',
              params: {
                errorEx: 'Invalid authentication. Please login.',
              },
            });
          }

          const errorData = {
            id: '',
            alertType: 'error',
            message: '',
          };
          if (error.code === 'ERR_NETWORK') {
            errorData.message = 'Network error. Please check your connection.';
          } else {
            errorData.message = error.response.data.violations.shift().message;
          }

          this.alertData.push(errorData);
        });
    },
    async loadFloors(houseId: number) {
      await axios
        .get(`${this.$store.getters.getApiUrl}/api/floors`, {
          headers: {
            'X-AUTH-TOKEN': this.$store.getters.getApiToken,
          },
          params: {
            home_id: houseId,
            'order[id]': 'DESC',
          },
          responseType: 'json',
        })
        .then((response) => {
          response.data.forEach((value: {
            id: number,
            name: string,
            rooms: []
          }) => {
            this.floors.push({
              text: `${value.name} (${value.rooms.length} rooms)`,
              value: value.id,
            });
          });

          // auto select a floor if there is only one selection
          if (this.floors.length === 1) {
            const singleFloorData = JSON.parse(JSON.stringify(this.floors[0]));
            this.floorId = singleFloorData.value;
          }
        })
        .catch((error) => {
          /** Authentication checker
           * @TODO optimize this code, make a base interface for this codes aside from validating
           * each page route changed in router/index.ts
           * */
          if (error.response.data.message === 'Invalid credentials.'
            || error.response.status === 401) {
            this.$store.commit('updateAuthenticatedAccount', {
              accountId: null,
              apiToken: null,
            });
            this.$router.push({
              name: 'login',
              params: {
                errorEx: 'Invalid authentication. Please login.',
              },
            });
          }

          const errorData = {
            id: '',
            alertType: 'error',
            message: '',
          };
          if (error.code === 'ERR_NETWORK') {
            errorData.message = 'Network error. Please check your connection.';
          } else {
            errorData.message = error.response.data.violations.shift().message;
          }

          this.alertData.push(errorData);
        });
    },
    async loadRooms(floorId: number) {
      await axios
        .get(`${this.$store.getters.getApiUrl}/api/rooms`, {
          headers: {
            'X-AUTH-TOKEN': this.$store.getters.getApiToken,
          },
          params: {
            floor_id: floorId,
            'order[id]': 'DESC',
          },
          responseType: 'json',
        })
        .then((response) => {
          response.data.forEach((value: {
            id: number,
            name: string,
            cupboards: []
          }) => {
            this.rooms.push({
              text: `${value.name} (${value.cupboards.length} shelves)`,
              value: value.id,
            });
          });

          // auto select a room if there is only one selection
          if (this.rooms.length === 1) {
            const singleRoomData = JSON.parse(JSON.stringify(this.rooms[0]));
            this.roomId = singleRoomData.value;
          }
        })
        .catch((error) => {
          /** Authentication checker
           * @TODO optimize this code, make a base interface for this codes aside from validating
           * each page route changed in router/index.ts
           * */
          if (error.response.data.message === 'Invalid credentials.'
            || error.response.status === 401) {
            this.$store.commit('updateAuthenticatedAccount', {
              accountId: null,
              apiToken: null,
            });
            this.$router.push({
              name: 'login',
              params: {
                errorEx: 'Invalid authentication. Please login.',
              },
            });
          }

          const errorData = {
            id: '',
            alertType: 'error',
            message: '',
          };
          if (error.code === 'ERR_NETWORK') {
            errorData.message = 'Network error. Please check your connection.';
          } else {
            errorData.message = error.response.data.violations.shift().message;
          }

          this.alertData.push(errorData);
        });
    },
    async loadShelves(roomId: number) {
      await axios
        .get(`${this.$store.getters.getApiUrl}/api/cupboards`, {
          headers: {
            'X-AUTH-TOKEN': this.$store.getters.getApiToken,
            // Accept: 'application/ld+json',
          },
          params: {
            room_id: roomId,
            'order[id]': 'DESC',
          },
          responseType: 'json',
        })
        .then((response) => {
          response.data.forEach((value: {
            id: number,
            name: string,
          }) => {
            this.shelves.push({
              text: value.name,
              value: value.id,
            });
          });

          // auto select a shelf if there is only one selection
          if (this.shelves.length === 1) {
            const singleShelfData = JSON.parse(JSON.stringify(this.shelves[0]));
            this.shelfId = singleShelfData.value;
          }
        })
        .catch((error) => {
          /** Authentication checker
           * @TODO optimize this code, make a base interface for this codes aside from validating
           * each page route changed in router/index.ts
           * */
          if (error.response.data.message === 'Invalid credentials.'
            || error.response.status === 401) {
            this.$store.commit('updateAuthenticatedAccount', {
              accountId: null,
              apiToken: null,
            });
            this.$router.push({
              name: 'login',
              params: {
                errorEx: 'Invalid authentication. Please login.',
              },
            });
          }

          const errorData = {
            id: '',
            alertType: 'error',
            message: '',
          };
          if (error.code === 'ERR_NETWORK') {
            errorData.message = 'Network error. Please check your connection.';
          } else {
            errorData.message = error.response.data.violations.shift().message;
          }

          this.alertData.push(errorData);
        });
    },
    async uploadImageApi() {
      const data = new FormData();
      data.append('image', this.browseImageFile);
      // data.append('is_landscape', 'false');

      return axios
        .post(`${this.$store.getters.getApiUrl}/api/images/upload`, data, {
          headers: {
            'X-AUTH-TOKEN': this.$store.getters.getApiToken,
          },
        })
        .catch((error) => {
          /** Authentication checker
           * @TODO optimize this code, make a base interface for this codes aside from validating
           * each page route changed in router/index.ts
           * */
          if (error.response.data.message === 'Invalid credentials.'
            || error.response.status === 401) {
            this.$store.commit('updateAuthenticatedAccount', {
              accountId: null,
              apiToken: null,
            });
            this.$router.push({
              name: 'login',
              params: {
                errorEx: 'Invalid authentication. Please login.',
              },
            });
          }

          const errorData = {
            id: '',
            alertType: 'error',
            message: '',
          };
          if (error.code === 'ERR_NETWORK') {
            errorData.message = 'Network error. Please check your connection.';
          } else if (error.response.data.violations) {
            errorData.message = error.response.data.violations.shift().message;
          } else {
            errorData.message = 'Server side upload configuration error. Please contact an administrator.';
          }

          // scroll up top to show error message
          goTo(0);

          this.alertData.push(errorData);
        });
    },
    async submitButton() {
      this.testSubmitData();
      this.alertData = [] as object[];

      if (this.valid) {
        this.$store.commit('setProgressLoader', true);

        const boxRequestData = {
          cupboardId: this.shelfId,
          imageId: null,
        };

        if (this.browseImageFile) {
          await this.uploadImageApi()
            .then((response) => {
              // this.uploadedImageId = response?.data.image_id;
              boxRequestData.imageId = response?.data.image_id;
            });
        }

        await axios
          .post(`${this.$store.getters.getApiUrl}/api/boxes`, boxRequestData, {
            headers: { 'X-AUTH-TOKEN': this.$store.getters.getApiToken },
          })
          .then((response) => {
            if (response.status !== 201) {
              this.alertData.push({
                id: this.alertData.length,
                alertType: 'error',
                message: 'There is something wrong while saving. Please contact an administrator.',
              });
            } else {
              this.alertData.push({
                id: this.alertData.length,
                alertType: 'success',
                message: 'Successfully added a new box',
              });
              this.showNewBoxNumber = true;
              this.newBoxNumber = response.data.box_number;
              this.formEl.reset();
            }
          })
          .catch((error) => {
            /** Authentication checker
             * @TODO optimize this code, make a base interface for this codes aside from validating
             * each page route changed in router/index.ts
             * */
            if (error.response.data.message === 'Invalid credentials.'
              || error.response.status === 401) {
              this.$store.commit('updateAuthenticatedAccount', {
                accountId: null,
                apiToken: null,
              });
              this.$router.push({
                name: 'login',
                params: {
                  errorEx: 'Invalid authentication. Please login.',
                },
              });
            }

            const errorData = {
              id: '',
              alertType: 'error',
              message: '',
            };
            if (error.code === 'ERR_NETWORK') {
              errorData.message = 'Network error. Please check your connection.';
            } else {
              errorData.message = error.response.data.violations.shift().message;
            }

            this.alertData.push(errorData);

            // scroll up top to show error message
            goTo(0);
          })
          .finally(() => {
            this.$store.commit('setProgressLoader', false);
          });
      } else {
        // scroll up top to show error message
        goTo(0);
      }
    },
  },
});
